import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'

import { useTRPC } from '@lib/trpc'

export const useSupportBeacon = (prefetch: boolean) => {
  const trpc = useTRPC()
  const queryClient = useQueryClient()
  const options = { ...trpc.support.beacon.queryOptions(), staleTime: Infinity }
  useQuery({ ...options, enabled: prefetch })
  const getBeaconId = async () => (await queryClient.ensureQueryData(options)).beaconId
  return { getBeaconId }
}

export const useSendSupportMessageMutation = () => {
  const trpc = useTRPC()
  const mutation = useMutation(trpc.support.send.mutationOptions())
  return { sendSupportMessage: mutation.mutateAsync, sendSupportMessageIsPending: mutation.isPending }
}
